export default __webpack_public_path__ + "static/media/international-academy-traducation.be115525.svg";